// HEADER TEXT
export const LOGOUT_TEXT = "Cerrar sesión"
export const ADMINISTRATION_HEADER = "Administración"
export const CLIENTS_HEADER = "Clientes"
export const HEADERNAME = "Funeraria del Magisterio"
export const HEADERSUBTITLE = "Sistema de Reservación"
export const RESERVATIONS_HEADER = "Reservaciones"
export const PARKINGS_HEADER = "Parqueos"

// Titles
export const LOGIN_TITLE = "Iniciar sesion"
export const EVENT_ID_TITLE = "ID del evento"
export const CLIENT_ID_TITLE = "ID del cliente"
export const USER_TITLE = "Usuario"
export const PASS_TITLE = "Contrasena"

// Errors on reservation
export const NO_ROOM_ERROR = "No hay espacio disponible para todos los invitados"
export const INVALID_NAME_ERROR = "El nombre que introdujo en datos personales no es válido"
export const INVALID_PHONE_ERROR = "El teléfono que introdujo en datos personales no es válido"
export const INVALID_RESERVATION_CODE = "El código de reservación no es válido"
export const INVALID_MAIL_ERROR = "El correo electrónico no es valido"
export const INVALID_PLATE_ERROR = "El numero de placa es invalido"
export const RESERVATION_NOT_FOUND_ERROR = "La reservación no existe"
export const RESERVATION_FAILED = "Reservación fallida"
export const UPDATE_FAILED = "Actualización fallida"
export const NO_ROOM_FOR_SELECTED_TIME = "No quedan espacios disponibles para esta hora"

// Error messages
export const INVALID_EVENT_ID = "El ID del evento no es valido"
export const INVALID_CLIENT_ID = "El ID del cliente no es valido"
export const WRONG_CLIENT_ID = "El ID del cliente es incorrecto"
export const EVENT_NOT_FOUND = "Evento no encontrado"
export const INVALID_USER_NAME = "El nombre de usuario no es valido"
export const UNAUTHORIZED_USER = "Usuario no autorizado"
export const WRONG_PASSWORD = "Contrasena incorrecta"

// Success messages
export const UPDATE_SUCCESS = "Se ha actualizado su reserva"
export const DELETE_SUCCESS = "Se ha eliminado su reserva"
export const RESERVATION_SUCCESS = "Reservación exitosa"

// Other texts
export const RESERVATION_WARNING = ""
export const CHOOSE_AN_OPTION_TEXT = "Escoja una opción..."
export const SANITARY_MEASURES_TEXT = "Les recordamos cumplir con las medidas sanitarias"
export const RESERVATION_TIME_WARNING = "**Cada reservación tiene validez por 1 hora de visita"
export const RESERVED_SPACES_HINT = "**Reserve espacios permanentes para miembros de la familia o que le acompañen durante toda la ceremonia"

// Buttons
export const UPDATE_BUTTON = "Actualizar"
export const DELETE_RESERVATION_BUTTON = "Eliminar reserva"
export const SEARCH_BUTTON = "Buscar"
export const RESERVATION_BUTTON = "Reservar"
export const VALIDATE_BUTTON = "Validar"

// Footer
export const FOOTER_PHONE = "8702-9655"
export const FOOTER_MAIL = "sanjose@funerariadelmagisterio.com"
export const FOOTER_WEBSITE = "www.funerariadelmagisterio.com"

//Termns and conditions
export const TERMS_AND_CONDITIONS = `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
    incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
    nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
    fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
    culpa qui officia deserunt mollit anim id est laborum.
`
